"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadUtils = void 0;
const getDimensions = (file) => {
    return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
            const image = new Image();
            if (e === null || e === void 0 ? void 0 : e.target)
                image.src = e.target.result;
            image.onload = function () {
                const height = image.height;
                const width = image.width;
                resolve({ width, height });
            };
        };
    });
};
const getImageFormat = (upload) => {
    if ((upload === null || upload === void 0 ? void 0 : upload.type) !== "image")
        return undefined;
    const { width, height } = upload;
    if (!width || !height)
        return undefined;
    if (width === height)
        return "square";
    if (width > height)
        return "landscape";
    return "portrait";
};
exports.uploadUtils = {
    getDimensions,
    getImageFormat,
};
//# sourceMappingURL=uploadUtils.js.map